import { gql } from "@apollo/client";

export type PricingTrendItem = {
  id: string;
  capturedAt: string;
  marketValue: number;
  langermanFactor: number;
  competitorFactor: number;
  color: {
    color: string;
    valid: boolean;
  };
};

export type GetLatestPricingTrendsQueryData = {
  latestPricingTrends: PricingTrendItem[];
};

// Each color's most recent trend: the factor matrix shows where the factors stand, not their history.
export const GET_LATEST_PRICING_TRENDS = gql`
  query LatestPricingTrends {
    latestPricingTrends {
      id: iD
      capturedAt
      marketValue
      langermanFactor
      competitorFactor
      color {
        color
        valid
      }
    }
  }
`;
